import { replace, size, split, toNumber } from 'lodash';
import { SUPPORTED_LOCALES } from '@trip-ux/constants';
import { environment } from 'apps/admin/src/environments/environment';
import { getAEM } from '@trip-ux/common';

const regEx = RegExp('[^\\d.]', 'g');
const regExFr = RegExp('[^\\d.,]', 'g');
const regMeta = RegExp('[.,]', 'gi');

const advisorProfileTypes = ['ADVISOR', 'ADVISOR_UNLICENSED'];
export const isAdvisorProfile = (profileType: string): boolean => {
  return advisorProfileTypes.includes(profileType);
};

export const checkCurrency = (e, locale: SUPPORTED_LOCALES, onChange) => {
  const cleanedValue = replace(e.target.value, locale === SUPPORTED_LOCALES.FRENCH ? regExFr : regEx, '');
  if (size(cleanedValue.match(regMeta)) <= 1) {
    const arr = cleanedValue.indexOf(',') !== -1 ? split(cleanedValue, ',') : split(cleanedValue, '.');
    if (size(arr) <= 2 && size(arr) > 1 && size(arr[1]) < 3) {
      onChange(toNumber(cleanedValue));
    } else if (size(arr) < 2) {
      onChange(toNumber(cleanedValue));
    }
  }
};

export const blurCheck = (e, locale: SUPPORTED_LOCALES, onBlur) => {
  const cleanedValue = replace(e.target.value, locale === SUPPORTED_LOCALES.FRENCH ? regExFr : regEx, '');
  const arr = cleanedValue.indexOf(',') !== -1 ? split(cleanedValue, ',') : split(cleanedValue, '.');
  if (size(arr) > 1 && size(arr[1]) === 0) {
    onBlur(toNumber(arr[0]));
  } else {
    onBlur(toNumber(cleanedValue));
  }
};

export const navigateToPage = (link: string): void => {
  window.location.href = link;
};

export const getWebLinks = (lang, refCode) => {
  return lang === 'en'
    ? environment.webLinks.webLinksEN.replace('${lang}', lang).replace('${refCode}', refCode)
    : environment.webLinks.webLinksFR.replace('${lang}', lang).replace('${refCode}', refCode);
};

export const getAEMUrl = (screen, lang, profileType?) => {
  if (screen === 'landing') {
    const isAdvisor = isAdvisorProfile(profileType);
    const landingUrl = isAdvisor
      ? getAEM(environment.maintenance.landingAdvisor, lang)
      : getAEM(environment.maintenance.landing, lang);
    return window.location.origin + landingUrl;
  }

  if (screen === 'faqs') {
    const faqsUrl = getAEM(environment.maintenance.faqs, lang);
    return window.location.origin + faqsUrl;
  }

  if (screen === 'contactUs') {
    const contactUsUrl = getAEM(environment.maintenance.contactUs, lang);
    return window.location.origin + contactUsUrl;
  }

  if (screen === 'resource') {
    const resourceUrl = getAEM(environment.maintenance.resource, lang);
    return window.location.origin + resourceUrl;
  }

  if (screen === 'advisorResource') {
    const resourceUrl = getAEM(environment.maintenance.advisorResource, lang);
    return window.location.origin + resourceUrl;
  }

  if (screen === 'advisorContactUs') {
    const resourceUrl = getAEM(environment.maintenance.advisorContactUs, lang);
    return window.location.origin + resourceUrl;
  }
  return undefined;
};
